import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Form } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const NewContextModal = ({orgId, show, toggle}) => {
  const [currentState, dispatch] = useStateValue()

  const [newContextId, updateNewContextId] = useState('')
  const [newContextTitle, updateNewContextTitle] = useState('')
  const [canvasCourseId, updateCanvasCourseId] = useState('')

  const handleContextIdChange = e => {
    updateNewContextId(e.target.value)
  }

  const handleContextTitleChange = e => {
    updateNewContextTitle(e.target.value)
  }

  const handleCanvasCourseIdChange = e => {
    updateCanvasCourseId(e.target.value)
  }

  const AddNewContext = async () => {
    try {
      await client.post(endpoints.addNewContext({ orgId: orgId }), {
        contextId: newContextId,
        contextTitle: newContextTitle,
        canvasCourseId: canvasCourseId,
      })

      toast.success("Successfully added new context.")
      // Trigger the lower components useEffect hook
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      console.log(err)
      toast.error("There was an error trying to create a new context.")
    } finally {
      toggle(!show)
    }
  }

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>New Context</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="contextId">
          <Form.Label>New Context Id</Form.Label>
          <Form.Control
            type="text"
            onChange={handleContextIdChange}
            value={newContextId}
          />
        </Form.Group>
        <Form.Group controlId="contextTitle">
          <Form.Label>New Context Title</Form.Label>
          <Form.Control
            type="text"
            onChange={handleContextTitleChange}
            value={newContextTitle}
          />
        </Form.Group>
        <Form.Group controlId="canvasCourse">
          <Form.Label>Canvas Course ID</Form.Label>
          <Form.Control
            type="text"
            onChange={handleCanvasCourseIdChange}
            value={canvasCourseId}
          />
        </Form.Group>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => AddNewContext()}
        >
          <div className="fa-regular fa-plus fa-fw mr-2" /> Add Context
        </div>
      </Modal.Body>
    </Modal>
  )
}

NewContextModal.propTypes = {
  orgId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default NewContextModal
